import { hasKnownIncorrectModeling } from '@shared';
import { usePolicyById, useProjectionForPolicy } from './useProjectionForPolicy';

/**
 * True when the month-by-month projection-details view should be offered for a
 * policy. Two independent gates, both of which must pass:
 *
 * 1. The engine actually priced this policy (`policyProjectionSource`). A policy
 *    that fell back to legacy — an unported product, a CareMatters policy
 *    missing its benefit period, or a strategy that threw — has no ledger to
 *    show, so it keeps the legacy view. The projection itself is checked too,
 *    since the view reads it directly.
 *
 * 2. The product's modeling is not known to be wrong. `hasKnownIncorrectModeling`
 *    products are withheld even if they later gain a strategy: a detailed
 *    month-by-month breakdown of a number we know is materially wrong reads as
 *    more trustworthy than the summary, not less.
 */
export function useHasProjectionView(fundingSourceId: string | undefined): boolean {
  const projection = useProjectionForPolicy(fundingSourceId);
  const policy = usePolicyById(fundingSourceId);
  if (!projection || policy?.policyProjectionSource !== 'engine') return false;
  return !hasKnownIncorrectModeling(policy.policyType);
}
